import { Client } from './../../../models/client';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PNotifyService } from '../../../services/pnotify.service';
import * as moment from 'moment';
import { Select2OptionData } from 'ng2-select2';
// declare var jQuery: any;

@Component({
  selector: 'app-client-add',
  templateUrl: './client-add.component.html',
  styleUrls: ['./client-add.component.css']
})
export class ClientAddComponent implements OnInit {

  client: Client;
  passwordConfirm_ = '';
  pack: Array<Select2OptionData>;
  reservedUsernames: string[];
  pnotify = undefined;
  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    pnotifyService: PNotifyService
  ) {
    this.client = new Client();
    this.reservedUsernames = [];
    this.pack = [
      { id: '', text: 'Choisir un type' },
      { id : '1', text: 'Start' },
      { id : '2', text: 'Essentiel' },
      { id : '3', text: 'Pro' },
    ];
    this.http.get(
      '/api/client/reservedUsernames/0'
    ).subscribe((usernames: any[]) => {
      for (let i = 0; i < usernames.length; i++) {
        this.reservedUsernames.push(usernames[i].username);
      }
    });
    this.pnotify = pnotifyService.getPNotify();
  }

  ngOnInit() {
    $('#image-cropper').cropit({
      allowDragNDrop: false,
      smallImage: 'allow',
      imageState: { src: 'assets/images/user.png' }
    });
    $('.select-image-btn').click(function () {
      $('.cropit-image-input').click();
    });
  }

  onUsernameChange() {
    this.client.username = this.client.username.replace(/\s/g, '');
  }

  packChanged(e: any) {
    this.client.pack = e.value;
  }

  onSubmit(): void {
    this.client.expiration = moment(this.client.expiration).format('YYYY-MM-DD HH:mm:ss');
    this.client.passwordBrute = this.client.password;
    const previewSize = $('#image-cropper').cropit('previewSize');
    const quality = previewSize.width > 100 ? 100 / previewSize.width : 1;
    if ($('#image-cropper').cropit('imageSrc')) {
      this.client.image = $('#image-cropper').cropit('export', {
        type: 'image/jpeg',
        quality: quality,
        fillBg: '#fff',
        originalSize: false
      });
    }
    this.http.post(
      '/api/client/0',
      { client: this.client }
    ).subscribe(
      (client: Client) => {
        this.client = client;
        this.router.navigate(['/client/view', this.client.id]);
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/client/client-add/client-add.component.ts